/* eslint-disable react/display-name */
import * as React from 'react';

const Plus = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      d="M9.2,9.2v4.7A1.11,1.11,0,0,1,8.1,15H7.9a1.11,1.11,0,0,1-1.1-1.1V9.2H2.1A1.11,1.11,0,0,1,1,8.1V7.9A1.11,1.11,0,0,1,2.1,6.8H6.8V2.1A1.11,1.11,0,0,1,7.9,1h.2A1.11,1.11,0,0,1,9.2,2.1V6.8h4.7A1.11,1.11,0,0,1,15,7.9v.2a1.11,1.11,0,0,1-1.1,1.1Z"
      style={{ fill: 'inherit', fillRule: 'evenodd' }}
    />
  </svg>
);

export default Plus;
